import {registerMPElement} from '../../../../util/register-element';
import {BuilderPaneBase} from '../../common-components/builder-pane-base/index';
import {FREQUENCY_OPERATOR_LIST} from '../../models/constants';

import template from './index.jade';
import css from './index.styl?inline';

export default registerMPElement(
  `cohorts-builder-frequency`,
  class FrequencyBuilderPane extends BuilderPaneBase {
    get config() {
      return {
        ...super.config,
        useShadowDom: true,
        css,
        template,
        helpers: {
          ...super.config.helpers,
          FREQUENCY_OPERATOR_LIST,
          getSelectedFrequencyOperator: () => {
            const {stagedCohort, stagedClausePosition} = this.state;
            return stagedCohort.getFrequencyOperator(stagedClausePosition);
          },
          clickedFrequencyOperator: (frequencyOperator) => {
            this.dispatchBubbledEvent(`selected-frequency-operator`, frequencyOperator);
          },
        },
      };
    }
  },
);
